import React from 'react';
import { DeliveryIcon, GrayDeliveryIcon } from './icons';

const ShippingLabelBanner = ({ isFlatRate }: { isFlatRate: boolean }) => {
  return !isFlatRate ? (
    <div className="w-full border-t border-gray-300 bg-gray-100 p-[2.4rem]">
      <div className="flex gap-[1.6rem]">
        <DeliveryIcon />
        <div>
          <h5 className="text-[1.8rem] font-semibold">
            Use MX Locker Shipping Label
          </h5>
          <p className="mt-[.8rem] text-brand-dark-gray">
            USPS First Class Mail, Priority Mail, or UPS Ground - customer
            selects at checkout.
          </p>
        </div>
      </div>
    </div>
  ) : (
    <div className="w-full border-t border-gray-300 bg-gray-100 p-[2.4rem]">
      <div className="flex gap-[1.6rem]">
        <GrayDeliveryIcon />
        <div>
          <h5 className="text-[1.8rem] font-semibold">
            Use My Own Shipping Label
          </h5>
          <p className="mt-[.8rem] text-brand-dark-gray">
            After your listing is sold, we&apos;ll ask you to provide your own
            shipping label and upload the tracking number to the MX Locker
            website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingLabelBanner;
